__turbopack_context__.v({
  "arrow": "Tooltip-module-scss-module__YFFf6a__arrow",
  "bottom": "Tooltip-module-scss-module__YFFf6a__bottom",
  "bottomStart": "Tooltip-module-scss-module__YFFf6a__bottomStart",
  "content": "Tooltip-module-scss-module__YFFf6a__content",
  "left": "Tooltip-module-scss-module__YFFf6a__left",
  "right": "Tooltip-module-scss-module__YFFf6a__right",
  "tooltip": "Tooltip-module-scss-module__YFFf6a__tooltip",
  "top": "Tooltip-module-scss-module__YFFf6a__top",
  "wide": "Tooltip-module-scss-module__YFFf6a__wide",
});
